<ng-container *ngIf="node.children.length; else leaf">
  <button *ngIf="node.section" type="button" class="layout-menuitem-root-text" [class.active-trail]="inActiveTrail" (click)="toggle()"
    [attr.aria-expanded]="expanded" [attr.aria-controls]="submenuId">
    <span class="layout-menuitem-text">{{ node.label | translate }}</span>
    <i class="pi pi-angle-down layout-submenu-toggler" aria-hidden="true"></i>
  </button>

  <button *ngIf="!node.section && !node.routerLink" type="button" class="layout-menuitem-link"
    [class.active-trail]="inActiveTrail" (click)="toggle()"
    [attr.aria-expanded]="expanded" [attr.aria-controls]="submenuId">
    <i [ngClass]="node.icon" class="layout-menuitem-icon" aria-hidden="true"></i>
    <span class="layout-menuitem-text">{{ node.label | translate }}</span>
    <i class="pi pi-angle-down layout-submenu-toggler" aria-hidden="true"></i>
  </button>

  <div *ngIf="!node.section && node.routerLink" class="layout-menuitem-split" [class.active-trail]="inActiveTrail">
    <a class="layout-menuitem-link" [routerLink]="node.routerLink" routerLinkActive="active-route"
      [routerLinkActiveOptions]="exactMatch" (click)="expand()">
      <i [ngClass]="node.icon" class="layout-menuitem-icon" aria-hidden="true"></i>
      <span class="layout-menuitem-text">{{ node.label | translate }}</span>
    </a>
    <button type="button" class="layout-submenu-toggle" (click)="toggle()" [attr.aria-label]="node.label | translate"
      [attr.aria-expanded]="expanded" [attr.aria-controls]="submenuId">
      <i class="pi pi-angle-down layout-submenu-toggler" aria-hidden="true"></i>
    </button>
  </div>

  <div class="layout-submenu" [class.layout-submenu-expanded]="expanded" [id]="submenuId">
    <ul>
      <li *ngFor="let child of node.children; trackBy: trackByKey" app-menuitem [node]="child"></li>
    </ul>
  </div>
</ng-container>

<ng-template #leaf>
  <a class="layout-menuitem-link" [routerLink]="node.routerLink" routerLinkActive="active-route"
    [routerLinkActiveOptions]="subsetMatch">
    <i [ngClass]="node.icon" class="layout-menuitem-icon" aria-hidden="true"></i>
    <span class="layout-menuitem-text">{{ node.label | translate }}</span>
  </a>
</ng-template>
